var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HomeScreen-container"},[(_vm.isMobile)?_c('MobileHomeView'):_c('PCHomeView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }